<template>
  <div
    class="flex items-center gap-2 p-0.5 text-base cursor-pointer text-EXPONDO-primary
      bg-EXPONDO-white rounded border border-EXPONDO-primary-20 min-w-max"
    :class="{ 'pl-1': !iconUrl, 'pr-1': currentItem.hideChevron }"
    data-testid="mainCategoryCarouselItem"
    @click="itemClick"
  >
    <div
      v-if="iconUrl"
      class="inline-block w-7 h-7"
    >
      <ImgView
        :src="iconUrl"
        default-src="/icons/categories/category.svg"
        class="pointer-events-none"
      />
    </div>
    <span
      :class="[
        color,
        isBold ? 'font-bold' : 'font-normal']"
      class="text-sm h-7 flex items-center"
    >
      {{ currentItem.name }}
    </span>
    <span
      v-if="!currentItem.hideChevron"
      class="ml-2 iconify svg--chevron-right text-sm transform rotate-90 text-EXPONDO-primary"
    />
  </div>
</template>
<script lang="ts">


import getCategoryIcon from '~~/helpers/category/getCategoryIcon';
import type { NavBarCategory } from '~~/types/category/NavBarCategory';
import { SECOND_HAND_CATEGORY_KEY } from '~~/constants/categoriesKeys';

export default defineComponent({
  name: 'NavMainBarCategory',

  props: {
    currentItem: {
      type: Object as PropType<NavBarCategory>,
      default: () => {

        return {};
      
      },
    },
    bold: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'text-EXPONDO-primary',
    },
  },
  setup(props) {

    const {
      toggleNavigation,
      isNavigationOpen,
      setFirstLevelCategory,
      currentFirstLevelCategorySlug,
    } = useNavigationState();
    const router = useRouter();
    const { addPrefixToSlugIfNecessary } = usePrefix();

    const itemClick = () => {

      if (props.currentItem.link) {

        router.push(addPrefixToSlugIfNecessary(props.currentItem.link));
        isNavigationOpen.value && toggleNavigation();

        return;
      
      }

      const slug = props.currentItem.slug;

      if (!isNavigationOpen.value || slug === currentFirstLevelCategorySlug.value) {

        toggleNavigation();
      
      }
      setFirstLevelCategory(slug);
    
    };

    const iconUrl = computed<string | null>(() => {

      return getCategoryIcon(props.currentItem.key);
    
    });

    const isBold = computed<boolean>(() => {

      return props.bold || props.currentItem.key === SECOND_HAND_CATEGORY_KEY;
    
    });

    return {
      itemClick,
      iconUrl,
      isBold,
    };
  
  },
});

</script>
